<template>
  <div id="app">
    <div v-if="isLoading" class="spinner">
      <font-awesome-icon icon="spinner" class="fa-spin"/>
    </div>
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    computed: {
      isLoading: function () {
        return this.$store.getters.isPageLoading;
      },
    }
  }
</script>

<style lang="scss">
  @import "./assets/css/layout.shared";

  #app {
    font-family: 'Open Sans', sans-serif;
  }

</style>
